import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "./form.scss";
import "./index.scss";
import { unregister } from "./registerServiceWorker";
import Root from "./Root";
import store from "./store";

(window as any).RenderApp = () => {
  ReactDOM.render(
    <Provider store={store}>
      <Router>
        <Root />
      </Router>
    </Provider>,
    document.getElementById("root") as HTMLElement
  );
};
unregister();



// WEBPACK FOOTER //
// ./src/index.tsx